import { atomWithStorage } from 'utils/atomWithStorage';
import { useAtomValue, useSetAtom } from 'jotai';

const defaultCycle = atomWithStorage<string>('boDefaultCycle', 'Cycle 2');

export function useDefaultCycle() {
  return useAtomValue(defaultCycle);
}

export function useSetDefaultCycle() {
  return useSetAtom(defaultCycle);
}
